import { countryOfOperatingZone } from '@orus.eu/operating-zone'
import { formatPhoneNumber } from '@orus.eu/phone-number'

import { useOperatingZone } from '../operating-zone-context.ts'

/**
 * Formats a stored phone number for the person viewing it: in its national format when it belongs to their market's
 * country, in its international format otherwise, and as it is when it is not a valid number.
 */
export function useFormatPhoneNumber(): (phone: string) => string {
  const operatingZone = useOperatingZone()
  const viewerCountry = countryOfOperatingZone[operatingZone]
  return (phone) => formatPhoneNumber(phone, viewerCountry)
}
